<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <a-row :gutter="24" type="flex" justify="space-between">
        <a-col
          v-for="(stat, i) in stats"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="4"
          :key="i"
          class="col"
        >
          <a-card :class="`box--${stat.type}`" class="box" :bordered="false">
            <a-icon
              v-bind="{
                [typeof icon(stat.type) === 'string'
                  ? 'type'
                  : 'component']: icon(stat.type)
              }"
              class="box__icon"
            />
            <a-statistic :title="stat.label" :value="stat.value" />
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
import { Stats } from '@/api/'
import StudentSvg from '@/assets/student.svg'
import ReservationSvg from '@/assets/reservation.svg'
import TakenClasses from '@/assets/taken-classes.svg'
import NextClass from '@/assets/next-class.svg'

export default {
  data() {
    return {
      stats: [],
      loading: false
    }
  },
  computed: {
    icon() {
      const iconsMap = {
        availabilities: 'calendar',
        'reserved-classes': ReservationSvg,
        students: StudentSvg,
        courses: 'laptop',
        'courses-names': 'laptop',
        'taken-classes': TakenClasses,
        'left-course-time': NextClass
      }

      return statType => iconsMap[statType]
    }
  },
  created() {
    this.fetchStatistics()
  },
  methods: {
    fetchStatistics() {
      this.loading = true
      Stats.fetch()
        .then(res => {
          this.stats = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.col {
  flex: 1;
}

.box {
  display: flex;
  align-items: center;
  height: 144px;
  margin-bottom: 24px;

  ::v-deep {
    .ant-card-body {
      display: flex;
      align-items: center;
      padding: 32px;
    }

    .ant-statistic {
      display: flex;
      flex-direction: column;
    }

    .ant-statistic-content {
      font-size: 34px;
      font-weight: 600;

      margin-top: -0.25em;
      order: -1;
    }

    .ant-statistic-title {
      margin-top: -6px;
    }
  }

  &--courses-names ::v-deep {
    .ant-statistic-content {
      font-size: 17px;
      line-height: 1.4;
      white-space: pre-wrap;
    }

    .ant-statistic-title {
      margin-top: 0;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 56px;
    width: 56px;
    background-color: #f9f0ff;
    color: #722ed1;
    border-radius: 12px;
    font-size: 24px;
    margin-right: 30px;
    flex-shrink: 0;
    box-shadow: 4px 4px 28px rgba(#f9f0ff, 0.75);
  }
}
</style>
